import { useMutation, useQueryClient } from '@tanstack/react-query';
import { endpoints, ID } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';
import { credentialKeys } from './queryKeys';

export const useDeleteCredential = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (credentialId: ID) =>
      api.request(endpoints.integrationCredentials.delete(credentialId)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: credentialKeys.list() });
    },
  });
};
